import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const ResourceLoadingModal = () => {
  return (
    <Backdrop
      sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
      open>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default ResourceLoadingModal;
